<template>
  <div>
    <Suspense>
      <router-view/>
    </Suspense>
  </div>
</template>

<script setup>
import {useTenantStore} from "../stores/tenant";

const tenant = useTenantStore();

/**
 * Returns the current URL parameters with lower case keys.
 * @return {module:url.URLSearchParams}
 */
function lowerCaseParameters() {
  const searchParams = new URLSearchParams(window.location.search);
  const lowerCaseParams = new URLSearchParams();

  for (const [name, value] of searchParams) {
    lowerCaseParams.append(name.toLowerCase(), value);
  }
  return lowerCaseParams;
}

const urlParams = lowerCaseParameters();

tenant.setPartnerId(urlParams.get('partnerid'));
tenant.setExternalId(urlParams.get('externalid'));

</script>
